<script>
import { mapGetters, mapState } from 'vuex';
import dateDiff from '../../filters/dateDiff';
import dateFormat from '../../filters/dateFormat';

export default {
  data: () => ({
    parsedUptime: '',
    parsedExpireTime: '',
  }),
  computed: {
    ...mapGetters(['showExpiretime']),
    ...mapState([
      'state',
      'expiretime',
      'uptime',
    ]),
    formattedUptime() {
      return dateFormat(this.uptime);
    },
    formattedExpireTime() {
      return dateFormat(this.expiretime);
    },
    timeCopy() {
      if (this.showExpiretime) {
        return {
          title: this.state === 'EEXPIRED'
            ? this.$t('upc.meta.trial.expired.date', { date: this.formattedExpireTime })
            : this.$t('upc.meta.trial.active.date', { date: this.formattedExpireTime }),
          text: this.state === 'EEXPIRED'
            ? this.$t('upc.meta.trial.expired.timeDiff', { timeDiff: this.parsedExpireTime })
            : this.$t('upc.meta.trial.active.timeDiff', { timeDiff: this.parsedExpireTime }),
        };
      }
      return {
        title: this.$t('upc.meta.uptime.date', { date: this.formattedUptime }),
        text: this.$t('upc.meta.uptime.readable', { timeDiff: this.parsedUptime }),
      };
    },
  },
  methods: {
    buildStringFromValues({
      years, months, days, hours, minutes, seconds, firstDateWasLater, displaySecondsInStringReturn,
    }) {
      const result = [];
      const dateStrings = {
        year: this.$t('year'),
        years: this.$t('years'),
        month: this.$t('month'),
        months: this.$t('months'),
        day: this.$t('day'),
        days: this.$t('days'),
        hour: this.$t('hour'),
        hours: this.$t('hours'),
        minute: this.$t('minute'),
        minutes: this.$t('minutes'),
        second: this.$t('second'),
        seconds: this.$t('seconds'),
        firstDateWasLater: this.$t('ago'),
        delimiter: ' ',
      };
      const pluralize = (num, word) => `${num} ${dateStrings[word + (num === 1 ? '' : 's')]}`;

      if (years) result.push(pluralize(years, 'year'));
      if (months) result.push(pluralize(months, 'month'));
      if (days) result.push(pluralize(days, 'day'));
      if (hours) result.push(pluralize(hours, 'hour'));
      if (minutes) result.push(pluralize(minutes, 'minute'));
      if (seconds && ((!years && !months && !days && !hours && !minutes) || displaySecondsInStringReturn)) result.push(pluralize(seconds, 'second'));
      if (firstDateWasLater) result.push(dateStrings.firstDateWasLater);
      return result.join(dateStrings.delimiter);
    },
    runTimeDiff() {
      if (this.uptime) this.parsedUptime = this.buildStringFromValues(dateDiff(this.uptime, true));
      if (this.expiretime) this.parsedExpireTime = this.buildStringFromValues(dateDiff(this.expiretime, false));
    },
    letsGo() {
      this.runTimeDiff();
      this.interval = setInterval(() => {
        this.runTimeDiff();
      }, 1000);
    },
  },
  created() {
    this.letsGo();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<template>
  <p class="select-all" :title="timeCopy.title">{{ timeCopy.text }}</p>
</template>
